import { render, staticRenderFns } from "./ProductImageButton.vue?vue&type=template&id=eaa5e2ea&"
import script from "./ProductImageButton.vue?vue&type=script&lang=js&"
export * from "./ProductImageButton.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports